import request from '@/router/axios';

// 获取物资扣减单列表（分页）
export const getList = (data) => {
  return request({
    url: '/api/produce/material-deduction/select/page',
    method: 'post',
    data,
  });
};

// 获取物资扣减单列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: '/api/produce/material-deduction/select/distinct/page',
    method: 'post',
    data,
  });
};

// 获取物资扣减单详情
export const getDetail = (id) => {
  return request({
    url: '/api/produce/material-deduction/select/id',
    method: 'get',
    params: { id },
  });
};

// 新增物资扣减单
export const add = (data) => {
  return request({
    url: '/api/produce/material-deduction/insert',
    method: 'post',
    data,
  });
};

// 更新物资扣减单
export const update = (data) => {
  return request({
    url: '/api/produce/material-deduction/update',
    method: 'post',
    data,
  });
};

// 删除物资扣减单（单个）
export const remove = (id) => {
  return request({
    url: '/api/produce/material-deduction/delete/id',
    method: 'get',
    params: { id },
  });
};

// 批量删除物资扣减单
export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/material-deduction/delete/ids',
    method: 'get',
    params: { ids },
  });
};

// 导出物资扣减单
export const exportExcel = (data) => {
  return request({
    url: '/api/produce/material-deduction/export/excel',
    method: 'post',
    data,
    responseType: 'blob',
  });
};

export const getContractExtpage = (params) => {
  return request({
    url: '/api/produce/transport-contract-ext/select/contractExtpage',
    method: 'get',
    params
  })
}
